import {
  MIN_WINDOW_HEIGHT,
  MIN_WINDOW_WIDTH,
} from 'components/DeviceView/deviceViewConstants';

interface Dimensions {
  height: number;
  width: number;
}

export const getContainerDimensions = (
  container: HTMLElement | null,
): Dimensions => {
  if (container) {
    const style = getComputedStyle(container);
    const width = Number.parseInt(style.width, 10);
    const height = Number.parseInt(style.height, 10);
    return { height, width };
  }
  return { height: MIN_WINDOW_HEIGHT, width: MIN_WINDOW_WIDTH };
};
